import { NgModule } from '@angular/core';
// primeng modules
import {ToggleButtonModule} from 'primeng/togglebutton';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {PasswordModule} from 'primeng/password';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule,FormControl, FormGroup, Validators } from '@angular/forms';
import { ScvMaterialModule } from 'src/material/material.module';
import { PopoverModule } from 'ngx-popover';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'ngx-avatar'
import { TruncatePipe } from '../pipes/truncate.pipe';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {MultiSelectModule} from 'primeng/multiselect';
import {CalendarModule} from 'primeng/calendar';
import {TriStateCheckboxModule} from 'primeng/tristatecheckbox';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import {TooltipModule} from 'primeng/tooltip';
import {SidebarModule} from 'primeng/sidebar';

@NgModule({
  imports: [
    InputTextModule,
    InputTextareaModule,
    PasswordModule,
    DropdownModule,
    ToggleButtonModule,
    ScrollPanelModule,
    CheckboxModule,
    TableModule,
    FormsModule,
    DialogModule,
    ReactiveFormsModule,
    ToggleButtonModule,
    ScvMaterialModule,
    ButtonModule,
    PopoverModule,
    CardModule,
    ToastModule,
    TranslateModule,
    AvatarModule,
    ConfirmDialogModule,
    MultiSelectModule,
    CalendarModule,
    MyDateRangePickerModule,
    TriStateCheckboxModule,
    TooltipModule,
    SidebarModule
  ],
  exports:[
    InputTextModule,
    InputTextareaModule,
    PasswordModule,
    DropdownModule,
    ToggleButtonModule,
    ScrollPanelModule,
    CheckboxModule,
    TableModule,
    FormsModule,
    DialogModule,
    ReactiveFormsModule,
    ToggleButtonModule,
    ScvMaterialModule,
    ButtonModule,
    PopoverModule,
    CardModule,
    ToastModule,
    TranslateModule,
    AvatarModule,
    TruncatePipe,
    ConfirmDialogModule,
    MultiSelectModule,
    CalendarModule,
    MyDateRangePickerModule,
    TriStateCheckboxModule,
    TooltipModule,
    SidebarModule
  ],
  declarations: [TruncatePipe]
})
export class ScvSharedModule { }
